import FUTUNN_LIGHT from './assets/pub_common_niuniu_refresh.js';
import MOOMOO_LIGHT from './assets/pub_common_moomoo_refresh.js';
import MOOMOO_DARK from './assets/skin_common_moomoo_refresh.js';
var FUTUNN_SIZE = 83;
var MOOMOO_SIZE = 150;
var FUTUNN_SPEED = 1000 / 24;
var MOOMOO_SPEED = 1000 / 25;
var FUTUNN_LIGHT_INFO = {
  SIZE: FUTUNN_SIZE,
  WIDTH: 332,
  HEIGHT: 249,
  XSLIDE: 4,
  YSLIDE: 3,
  IMAGE: FUTUNN_LIGHT,
  speed: FUTUNN_SPEED
};
var MOOMOO_LIGHT_INFO = {
  SIZE: MOOMOO_SIZE,
  WIDTH: 600,
  HEIGHT: 750,
  XSLIDE: 4,
  YSLIDE: 5,
  IMAGE: MOOMOO_LIGHT,
  speed: MOOMOO_SPEED
};
var MOOMOO_DARK_INFO = {
  SIZE: MOOMOO_SIZE,
  WIDTH: 600,
  HEIGHT: 750,
  XSLIDE: 4,
  YSLIDE: 5,
  IMAGE: MOOMOO_DARK,
  speed: MOOMOO_SPEED
};
export { FUTUNN_LIGHT_INFO, MOOMOO_LIGHT_INFO, MOOMOO_DARK_INFO };